import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function EditKeywords({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Edit Keywords'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

